import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
// State
import DashboardJustReleased from "../../Components/DashboardJustReleased";
import { getOrganisation } from "@intelligentlilli/api-layer";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "State/hooks";

const DashboardHeader = () => {
  const user = useAppSelector((state) => state.user.authData);
  const server = useAppSelector((state) => state.session.server);
  const [organisation, setOrganisation] = useState();
  const navigate = useNavigate();

  const showJustReleased = false;
  const videoSource = undefined;

  useEffect(() => {
    if (user?.organisationId) {
      getOrganisation(server, user.organisationId, "web")
        .then((res) => res.ok && setOrganisation(res.data))
        .catch((err) => {
          console.log(err);
        });
    }
  }, [user?.organisationId, navigate, server]);

  return (
    <div className={styles.dashboard_header_container}>
      <div>
        <div className={styles.page_title}>Dashboard</div>
        <div className={styles.user_info} data-private>
          {user?.forenames} {user?.surname} | {organisation?.name ?? ""}
        </div>
      </div>
      {showJustReleased && (
        <div className={styles.component_just_released}>
          <DashboardJustReleased
            releaseTitle={
              "Just Released: Add family members so they can see their loved ones' data"
            }
            releaseSubheading={
              "We’ve automated the invite process. Invite family from a user’s profile page."
            }
            videoSourceURL={videoSource}
          />
        </div>
      )}
    </div>
  );
};

export default DashboardHeader;
